export default "__VITE_ASSET__9dcf2f50__"